<mat-tab-group animationDuration="0ms">
    <mat-tab>
        <ng-template mat-tab-label>
            {{
                'admin.components.adminPerformance.overview' | translate
            }}</ng-template
        >
    </mat-tab>
</mat-tab-group>
